import React, { memo } from 'react';
import PropTypes from 'prop-types';
import className from 'classnames';
import { CurrencyUtils } from '../../../utils';
import { DayPriceEl } from './DayPrice.style';

export const DayPrice = memo(({ cheapest, hidden, loading, selected, value }) => {
    const classNames = className({
        'odf-text-xs': true,
        'odf-strong': true,
        'odf-text-mono-color-04': !cheapest && !selected,
        'odf-text-positive': !loading && cheapest && !selected,
        'odf-price-selected-loading': loading && selected,
    });

    const visibility = hidden ? 'hidden' : 'visible';

    if (hidden || loading) {
        return <DayPriceEl loading={loading ? 1 : 0} className={classNames} visibility={visibility} />;
    }

    if (value) {
        return (
            <DayPriceEl className={classNames} visibility={visibility}>
                {CurrencyUtils.getFormattedCalendarFares(value)}
            </DayPriceEl>
        );
    }

    return <DayPriceEl className="odf-icon odf-icon-s odf-icon-more" visibility={visibility} />;
});

DayPrice.propTypes = {
    cheapest: PropTypes.bool.isRequired,
    hidden: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    selected: PropTypes.bool.isRequired,
    value: PropTypes.number,
};

DayPrice.defaultProps = {
    value: 0,
};
